import { CwtApiSchema, CwtProp, CwtSchema } from "@cawita/core-front/api";
import { CompanyProduct } from "./company-product";

@CwtSchema()
export class Product extends CwtApiSchema {
    @CwtProp({ ref: CompanyProduct }) product: CompanyProduct;
    @CwtProp() quantity: number;
    @CwtProp() unitPrice: number;
}
